export { default as Perfil } from './VerPerfil';
export { default as EditarPerfil } from './EditarPerfil';
